import React from 'react';
import { Col, Row } from 'react-bootstrap';
import GoogleMap from '../../images/GoogleMap.png';

function Gauche(props) {
    return (
        <div>
            <Row style={{paddingBottom:'50px',display:'flex'}}>
                                <Col xl={2} lg={2} md={3} sm={12} xs={12} className='colImg' >
                                    <img 
                                    // data-Aos='fade-in'
                                     src={props.src} alt='img' className='imagePool' />
                                </Col>
                                <Col xl={8} lg={8} md={8} sm={12} xs={12} >
                                    <div className='poolHeaderwrapper'>
                                         <h3 data-Aos='fade-in' className='poolHeaderwrapperH3'>{props.title}</h3>
                                    </div>
                                <div 
                                // data-Aos='slide-up'
                                style={{paddingTop:'10px'}}>
                                <p style={{textAlign:'justify'}}>
                                    {props.text}
                                    {/* <a href={props.url} >Google map</a> */}
                                </p>
                                
                                
                            </div>
                        </Col>
                        <Col xl={2} lg={2} md={1} sm={12} xs={12}>
                                <div style={{textAlign:'center',marginTop:'40px'}}>
                                        <a className='googleBox' href={props.url}>
                                            <img className='mapP' src={GoogleMap} alt='map' />
                                            <p style={{marginTop:'10px',color:'#806000'}}>Google map</p>
                                        </a>
                                </div>
                        </Col>
                    </Row>
        </div>
    )
}

export default Gauche
